import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';

export const StyledImage = styled(Image)`
  border-radius: 4px;
`;

StyledImage.displayName = 'StyledImage';
